import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { IncidencesProvider } from 'modules/bookkeepers/hooks/IncidencesContext'
import useGetIncidences from 'modules/bookkeepers/hooks/useGetIncidences'
import IncidencesPageBody from 'modules/payroll_bundle/pages/IncidencesPage/components/_IncidencesPageBody'

interface Props {
  dataCollectionTable: React.ReactNode
  incidenceDetail: React.ReactNode
  openedIncidenceId: number
}

const EmployeeUpdatesDataCollectionContent = ({
  dataCollectionTable,
  incidenceDetail,
  openedIncidenceId,
}: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const { loading, incidences } = useGetIncidences({
    messageIncidencesOnly: false,
    filterTypeFromDashboard: '',
  })

  const handleCloseSidepanel = () => {
    navigate(navigation.compensations.employeeUpdatesDataCollection.fullPath())
  }

  return (
    <IncidencesProvider value={incidences}>
      <IncidencesPageBody
        incidencesTable={dataCollectionTable}
        incidenceDetail={incidenceDetail}
        selectedIncidenceId={openedIncidenceId}
        loading={loading}
        onCloseSidepanel={handleCloseSidepanel}
      />
    </IncidencesProvider>
  )
}

export default EmployeeUpdatesDataCollectionContent
